import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Bl } from "../../../interfaces/bl-export/blexport.interface";
import { BLDetailsValues } from "../../../interfaces/bl-export/request.bl.interface";

interface blExportState {
  blExportToEdit?: Bl;
  page: number;
  size: number;
  containerToUpdate?: BLDetailsValues;
  isFormUpdateContainer: boolean;
  containers: BLDetailsValues[];
}

const initialState: blExportState = {
  page: 0,
  size: 10,
  isFormUpdateContainer: false,
  containers: [],
};

const blExportSlice = createSlice({
  name: "blExport",
  initialState,
  reducers: {
    setBlExportToEdit: (state, action: PayloadAction<Bl | undefined>) => {
      state.blExportToEdit = action.payload;
    },
    setPageTableBlExport: (state, action: PayloadAction<number>) => {
      state.page = action.payload;
    },
    setSizeTableBlExport: (state, action: PayloadAction<number>) => {
      state.size = action.payload;
    },
    setContainerToUpdate: (
      state,
      action: PayloadAction<BLDetailsValues | undefined>
    ) => {
      state.containerToUpdate = action.payload;
    },
    setIsFormUpdateContainer: (state, action: PayloadAction<boolean>) => {
      state.isFormUpdateContainer = action.payload;
    },
    setContainers: (state, action: PayloadAction<BLDetailsValues[]>) => {
      state.containers = action.payload;
    },
  },
});

export const {
  setBlExportToEdit,
  setPageTableBlExport,
  setSizeTableBlExport,
  setContainerToUpdate,
  setIsFormUpdateContainer,
  setContainers,
} = blExportSlice.actions;

export default blExportSlice.reducer;
